import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UserSettingsService } from "../pb-screen/services/usersettings.service";
import { environment } from "../../environments/environment";
import { Title } from "@angular/platform-browser";
import { VersionSettings } from "../pb-screen/static/client/versionSettings";
import { MsalService, MsalBroadcastService } from "../msal";
import { MsalGuardConfiguration } from "../msal/msal.guard.config";
import { EventMessage, EventType } from "@azure/msal-browser";
import { Observable, Subject } from "rxjs";
import { MSAL_GUARD_CONFIG } from "../msal/constants";
import { filter, take, takeUntil } from "rxjs/operators";
import { select } from "@angular-redux/store";
import { ApplicationUser } from "../pb-screen/models/application.user.interface";
import { UsersAuthorizationService } from "../users-authorizations/user-authorization.service";

@Component({
  selector: "app-main-page",
  templateUrl: "./main-page.component.html"
})
export class MainPageComponent implements OnInit, OnDestroy {

  @select("applicationUser") applicationUser$: Observable<ApplicationUser>;

  public buisnessCentralUrl: string = environment.buisnessCentralUrl;
  public landingPageUrl: string;
  public showDepotInIcon: boolean = true;
  public showDepotOutIcon: boolean = true;
  public showDeliveryIcon: boolean = true;
  public showCollectionIcon: boolean = true;
  public showStackerScreen: boolean = false;
  private readonly _destroying$ = new Subject<void>();


  public isIframe = false;
  public loggedIn = false;
  showPBScreen: boolean;
  showTOScreen: boolean;
  showDriverAgenda: boolean;
  showTruckAgenda: boolean;
  showWeekPlanning: boolean;
  showPlanningBoard: boolean;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private readonly userSettingsService: UserSettingsService,
    public readonly titleService: Title,
    private msalBroadcastService: MsalBroadcastService,
    private authService: MsalService, 
    private readonly userAuthorizationService: UsersAuthorizationService
  ) {
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    this.checkoutAccount();
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
        takeUntil(this._destroying$)
      ).subscribe((result) => {
      this.checkAccount();
      if (result.eventType == "msal:loginSuccess") {
        this.SetApplicationDefaults();
      }
    });

    this.SetApplicationDefaults();
  }

  SetApplicationDefaults() {

    const account = this.authService.instance.getAllAccounts()[0];

    if (!this.authService.instance.getActiveAccount()) {
      this.authService.instance.setActiveAccount(account);
    }

    this.applicationUser$.subscribe((data) => {
    let title = "Go4Planning " + VersionSettings.versionNumber + " | Go4Tms Web Portal";
    this.titleService.setTitle(title); 

    this.showDepotInIcon = environment.depotInIcon != null ? environment.depotInIcon && this.userAuthorizationService.canAccessScreen("depot-in") : true;
    this.showDepotOutIcon = environment.depotOutIcon != null ? environment.depotOutIcon && this.userAuthorizationService.canAccessScreen("depot-out") : true;
    this.showDeliveryIcon = environment.deliveryIcon != null ? environment.deliveryIcon && this.userAuthorizationService.canAccessScreen("pb-screen") : true;
    this.showCollectionIcon = environment.collectionIcon != null ? environment.collectionIcon && this.userAuthorizationService.canAccessScreen("pb-screen") : true;
    this.showStackerScreen = environment.stackerIcon != null ? environment.stackerIcon && this.userAuthorizationService.canAccessScreen("stacker") : false;

    this.showPBScreen =  this.userAuthorizationService.canAccessScreen("pb-screen"); 
    this.showTOScreen =   this.userAuthorizationService.canAccessScreen("to-screen"); 
    this.showDriverAgenda = this.userAuthorizationService.canAccessScreen("driveragenda"); ;
    this.showTruckAgenda = this.userAuthorizationService.canAccessScreen("truckagenda");
    this.showWeekPlanning = this.userAuthorizationService.canAccessScreen("week-planning");
    this.showPlanningBoard = this.userAuthorizationService.canAccessScreen("planning");

    this.userSettingsService.getGolbalSettingByName("landingPage").subscribe((result: any[]) => {
      if (result.length) {
        this.landingPageUrl = environment.hubEndpointAddress + "/App/assets/images/backgrounds/" + result[0].value + ".jpg";
      }
    }); 
     });
  }

  checkoutAccount() {
    this.loggedIn = !!this.authService.getAccount();
  }

  login() {
    this.checkAccount();
    if (!this.loggedIn) {
      this.authService.loginPopup().subscribe((() => {
        this.checkAccount();
        if (this.loggedIn) {
          this.SetApplicationDefaults();
        }
      }));
    } else {
      this.SetApplicationDefaults();
    }
  }

  logout() {
    this.authService.logout();
  }


  onRightClick(page: string, queryParams: string = "") {
    window.open(environment.redirectUrl + "/" + page + queryParams);
    return false;
  }

  openNewTabToUsersPreferredWeekPlanning() {
    this.applicationUser$.pipe(
      filter(applicationUser => applicationUser != null),
      take(1)
    ).subscribe(applicationUser => {
      let page: string;

      if (applicationUser.weekPlanningPreferences?.tabletMode) {
        page = "/week-planning";
      } else if (!applicationUser.weekPlanningPreferences?.tabletMode) {
        page = "/multi-day-compact";
      }

      window.open(environment.redirectUrl + page);
    });
  }

  onClick(page: string, queryParams: string = "") {
    window.open(page + queryParams);
    return false;
  }

  checkAccount() {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
  }

  ngOnDestroy(): void {
    this._destroying$.next(null);
    this._destroying$.complete();
  }
}
